module.exports = __webpack_public_path__ + "img/2.6c57e8e3.jpg";